import {FormikProps} from 'formik';
import {RadioCheckInput} from '../../../app/interfaces/Forms';
import {AdminNewsFormValues, NewsCategory} from '../Types/news';
import {Col, Form, Row} from 'react-bootstrap';
import {useGetNewsCategories} from '../Hooks/NewsCategoryHooks';
import TextInputFormik from '../../../Components/Form/TextInputFormik';
import TextareaFormik from '../../../Components/Form/TextareaFormik';
import SelectFormik from '../../../Components/Form/SelectFormik';
import RadioInputFormik from '../../../Components/Form/RadioInputFormik';
import DateInputFormik from '../../../Components/Form/DateInputFormik';

interface AdminNewsFormLogicProps {
  formik: FormikProps<AdminNewsFormValues>;
}

const AdminNewsForm = ({formik}: AdminNewsFormLogicProps): JSX.Element | null => {
  const {data} = useGetNewsCategories();

  const moreTypeSelectOptions: RadioCheckInput<string>[] = [
    {label: 'URL externe', value: 'url'},
    {label: 'Aucune information supplémentaire', value: 'none', checked: true},
  ];

  const typeOptions: RadioCheckInput<string>[] = [
    {
      label: 'ADMIN.NEWS.FORM.TYPE.ENCART',
      value: 'encart',
      description: 'ADMIN.NEWS.FORM.TYPE.ENCART.DESC',
    },
    {
      label: 'ADMIN.NEWS.FORM.TYPE.POPUP',
      value: 'popup',
      description: 'ADMIN.NEWS.FORM.TYPE.POPUP.DESC',
    },
  ];

  const frequencyOptions: RadioCheckInput<string>[] = [
    {
      label: 'ADMIN.NEWS.FORM.FREQUENCY.SESSION',
      value: 'session',
      description: 'ADMIN.NEWS.FORM.FREQUENCY.SESSION.DESC',
    },
    {
      label: 'ADMIN.NEWS.FORM.FREQUENCY.ONCE',
      value: 'once',
      description: 'ADMIN.NEWS.FORM.FREQUENCY.ONCE.DESC',
    },
  ];

  return (
    <Form onSubmit={formik.handleSubmit} className="px-4">
      <Row className="mb-5 mt-0">
        <SelectFormik<AdminNewsFormValues>
          name={'category_id'}
          label={'ADMIN.NEWS.FORM.TYPE.PLACEHOLDER'}
          formik={formik}
          options={
            data?.map((category: NewsCategory) => ({label: category.title, value: category.id})) ??
            []
          }
        />
      </Row>
      <Row className="my-5">
        <TextInputFormik<AdminNewsFormValues>
          formik={formik}
          name="title"
          label="ADMIN.NEWS.FORM.SUBJECT"
        />
      </Row>
      <Row className="my-5">
        <TextareaFormik<AdminNewsFormValues>
          formik={formik}
          name="description"
          label="ADMIN.NEWS.FORM.DESCRIPTION"
          required={formik.values.type === 'popup'}
        />
      </Row>
      <Row className="my-5">
        <RadioInputFormik<AdminNewsFormValues>
          formik={formik}
          name={'moreType'}
          label="ADMIN.NEWS.FORM.MORETYPE"
          options={moreTypeSelectOptions}
        />
      </Row>
      <Row className="my-5">
        {formik.values.moreType === 'none' ? (
          ''
        ) : (
          <TextInputFormik<AdminNewsFormValues>
            formik={formik}
            name="news"
            label="ADMIN.NEWS.FORM.NEWS"
          />
        )}
      </Row>
      <Row className="my-5">
        <Col md={6}>
          <DateInputFormik<AdminNewsFormValues>
            name="start_date"
            label="ADMIN.NEWS.FORM.DATE.STARTED"
            formik={formik}
            max={
              formik.values.end_date
                ? new Date(formik.values.end_date).toISOString().slice(0, -8)
                : ''
            }
          />
        </Col>
        <Col md={6}>
          <DateInputFormik<AdminNewsFormValues>
            name="end_date"
            label="ADMIN.NEWS.FORM.DATE.ENDED"
            formik={formik}
            max={
              formik.values.start_date
                ? new Date(formik.values.start_date).toISOString().slice(0, -8)
                : new Date().toISOString().slice(0, -8)
            }
          />
        </Col>
      </Row>
      <Row className="mb-5 mt-10">
        <RadioInputFormik<AdminNewsFormValues>
          formik={formik}
          name={'type'}
          label="ADMIN.NEWS.FORM.DISPLAYTYPE"
          options={typeOptions}
          inline
        />
      </Row>
      {formik.values.type === 'popup' && (
        <Row className="my-5">
          <RadioInputFormik<AdminNewsFormValues>
            formik={formik}
            name={'frequency'}
            label="ADMIN.NEWS.FORM.FREQUENCY"
            options={frequencyOptions}
            inline
          />
        </Row>
      )}
    </Form>
  );
};

export default AdminNewsForm;
